<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Jugadas"   />

    <PlaysContent />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import PlaysContent from "@/components/Pages/Admin/Queries/plays-content.vue";

export default defineComponent({
  name: "PlaysContentPage",
  components: {
    PageTitle,
    PlaysContent,
  },
});
</script>
